<template>
  <div oncontextmenu="return true">
    <Card dis-hover :id="['game-'+gameData.gID]" class="thai-hilo-container">
      <game-header
        :title="title"
        game="thai-hilo"
        gameType="thai-hilo"
        :game-data="gameData"
        :draw-no="drawNo"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
      />

      <thai-hilo-result
        game="thai-hilo"
        gameType="thai-hilo"
        :game-data="gameData"
        :draw-result="drawResult"
        :show-drawing-animation="showDrawingAnimation"
        :disallow-betting="disallowBetting"
        :display-disallow-section="displayDisallowSection"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        @on-animation-end="gameOnAnimationEnd"
      />

      <thai-hilo-game
        game="thai-hilo"
        gameType="thai-hilo"
        :game-data="gameData"
        :draw-result="drawResult"
        :show-drawing-animation="showDrawingAnimation"
        :disallow-betting="disallowBetting"
        :display-disallow-section="displayDisallowSection"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :on-animation-end="gameOnAnimationEnd"
      />

      <thai-hilo-history
        game="thai-hilo"
        gameType="thai-hilo"
        :game-data="gameData"
        :draw-result="drawResult"
        :goodroad-on="goodroadOn"
        :stat="stat"
        :historical-data="historicalData"
        :game-code="gameCode"
        :game-id="gameData['gID']"
      />
    </Card>
  </div>
</template>

<script>
import GameHeader from "../commons/GameHeader";
import ThaiHiloResult from "./ThaiHiloResult";
import ThaiHiloGame from "./ThaiHiloGame";
import ThaiHiloHistory from "./ThaiHiloHistory";
import gameMixin from "../../mixins/game-mixin";
import VuePopper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  mixins: [gameMixin],
  props: ["goodroadOn"],
  components: {
    GameHeader,
    ThaiHiloResult,
    ThaiHiloGame,
    ThaiHiloHistory
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.thai-hilo-border {
  width: 100%;
}

.border-top {
  position: absolute;
  top: 0;
}
</style>

<style lang="scss">
.thai-hilo--container .ivu-card-body {
  padding: 0;
}
</style>
